/**
 * Factory functions for Tax Code structures.
 * Ensures consistent shape and DRY across CreateTaxCode and EditTaxCode.
 */

/**
 * @returns {Object} A new tax rate object
 */
export function createTaxRate() {
  return {
    rangeStart: 0,
    rangeEnd: 0,
    rateType: "",
    tax: 0,
  };
}

/**
 * @returns {Object} A new tax line object (with one default tax rate)
 */
export function createTaxLine() {
  return {
    taxLineName: "",
    taxRates: [createTaxRate()],
  };
}

/**
 * Creates a new tax detail object for the Create flow (includes UI metadata).
 * @param {number} [id=1] - Optional id for the detail row
 * @returns {Object} A new tax detail object
 */
export function createTaxDetail(id = 1) {
  return {
    shipFrom: "nil",
    shipTo: "nil",
    billTo: "nil",
    taxLines: [createTaxLine()],
    btnText: "Add Line",
    isRemovable: false,
    id,
  };
}
